/*
 * File: AppointmentBlock.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/21/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */

import Preferences from "services/preferences/Store";
import AppointmentColor from "utils/AppointmentColor";
import { useStore } from "utils/useStore";

const AppointmentBlock = (event, theme) => {
  const preferencesStore = useStore(Preferences);

  const boxShadowProp = {
    boxShadow: `0px 0px 0 ${theme.spacing(0.1)}px ${theme.palette.common.black}`
  };
  if (event.blockName) {
    //Style for transparencies
    return {
      style: {
        ...boxShadowProp,
        background: AppointmentColor.getColorRgbaString(event.color, 0.4),
        color: "black",
        border: "none"
      }
    };
  }
  const showApptColors = preferencesStore.get("apptColors");
  //Style for events when show appt colors turned off.
  if (!event.colors || !showApptColors)
    return {
      style: {
        ...boxShadowProp,
        background: "#E5E5E5",
        color: "black",
        border: "none"
      }
    };

  //Style for events when show appt colors turned on.
  return {
    style: {
      ...boxShadowProp,
      color: "black",
      ...AppointmentColor.getColorStyle(event.colors)
    }
  };
};

export default AppointmentBlock;
